import React from 'react'
import RegistrationForm from '../components/SignUpCandidate/RegistrationForm'
import NavBar from '../components/SignUpCandidate/NavBar'
import Footer from '../components/Footer'


function SignUpCandidate() {
  return (
    <div>
        <NavBar />
        <RegistrationForm />
        <Footer />
    </div>
  )
}

export default SignUpCandidate